import React, { useEffect } from 'react';
import '../styles/Testimonials.css';
import ScrollReveal from '../components/ScrollReveal';
import ScrollProgressIndicator from '../components/ScrollProgressIndicator';
import SEOHead from '../components/SEOHead';

function Testimonials() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const testimonials = [
    {
      name: "Shahnawaz Quazi",
      position: "Business Owner",
      project: "Outdoor Gym Equipment Manufacturing Website",
      projectUrl: "https://mfenterprises.vercel.app/",
      image: "/assets/images/Shahnawaz-Ainuddin.png",
      feedback: "QuantumFrame Studio delivered an exceptional website that perfectly showcases our gym equipment manufacturing business. Their attention to detail and professional approach helped us establish a strong online presence.",
      rating: 5,
      location: "Nagur, India"
    },
    {
      name: "Sajid Ali",
      position: "Travel Agency Director",
      project: "Travel Agency Website",
      projectUrl: "https://www.excellenttravels.co.in/",
      image: "/assets/images/Sajid-ali.jpeg",
      feedback: "Working with QuantumFrame Studio was a great experience. They created a beautiful and functional website that has significantly improved our travel agency's booking rates and customer engagement.",
      rating: 5,
      location: "Bhoapl, India"
    },
    {
      name: "Mr Riyaz",
      position: "Tourism Entrepreneur",
      project: "Travel Agency Website",
      projectUrl: "https://themarveltravels.com/",
      image: "/assets/images/mtcl.jpg",
      feedback: "The team at QuantumFrame Studio understood our vision perfectly. The website they created has helped us reach more customers and streamline our booking process. Highly recommended!",
      rating: 5,
      location: "Mumbai, India"
    },
    {
      name: "Mr Obito",
      position: "Content Creator",
      project: "YouTube Channel Content Management",
      projectUrl: "https://www.youtube.com/@Obitostsukuyomi",
      image: "/assets/images/obito.jpg",
      feedback: "QuantumFrame Studio's expertise in content management and video production has been instrumental in growing my YouTube channel. Their creative solutions and professional service exceeded my expectations.",
      rating: 5,
      location: "Bhopal, India"
    }
  ];

  const handleProjectClick = (projectUrl) => {
    window.open(projectUrl, '_blank', 'noopener,noreferrer');
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <span 
        key={index} 
        className={`tsti-star ${index < rating ? 'tsti-star-filled' : ''}`}
      >
        ★
      </span>
    ));
  };

  return (
    <div className="tsti-testimonials-container">
      <SEOHead page="testimonials" />
      <ScrollProgressIndicator />
      <div className="tsti-testimonials-video-background">
        <video autoPlay muted loop>
          <source src="/assets/video/full-backgroundvid.mp4" type="video/mp4" />
        </video>
      </div>
      <div className="tsti-testimonials-overlay"></div>
      
      <div className="tsti-testimonials-content">
        {/* Hero Section */}
        <div className="tsti-testimonials-hero">
          <div className="tsti-testimonials-header">
            <h1>Client Testimonials</h1>
            <p>Hear what our clients have to say about their experience with us</p>
            <div className="tsti-stats-row">
              <div className="tsti-stat">
                <h3>50+</h3>
                <p>Happy Clients</p>
              </div>
              <div className="tsti-stat">
                <h3>100%</h3>
                <p>Satisfaction Rate</p>
              </div>
              <div className="tsti-stat">
                <h3>24/7</h3>
                <p>Support</p>
              </div>
            </div>
          </div>
        </div>

        {/* Main Testimonials Grid */}
        <div className="tsti-testimonials-section">
          <div className="tsti-section-title">
            <h2>Success Stories</h2>
            <p>Real projects, real results, real satisfaction</p>
          </div>

          <div className="tsti-testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <ScrollReveal key={index}>
                <div 
                  className="tsti-testimonial-card"
                  onClick={() => handleProjectClick(testimonial.projectUrl)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      handleProjectClick(testimonial.projectUrl);
                    }
                  }}
                >
                  <div className="tsti-testimonial-header">
                    <div className="tsti-testimonial-image-container">
                      <img 
                        src={testimonial.image} 
                        alt={testimonial.name} 
                        className="tsti-testimonial-image"
                      />
                      <div className="tsti-click-indicator">
                        <span>View Project</span>
                      </div>
                    </div>
                    <div className="tsti-testimonial-info">
                      <h3>{testimonial.name}</h3>
                      <p className="tsti-position">{testimonial.position}</p>
                      <p className="tsti-location">{testimonial.location}</p>
                      <div className="tsti-rating">
                        {renderStars(testimonial.rating)}
                      </div>
                    </div>
                  </div>
                  
                  <div className="tsti-project-badge">
                    <span>{testimonial.project}</span>
                  </div>
                  
                  <div className="tsti-testimonial-content">
                    <p>"{testimonial.feedback}"</p>
                  </div>
                  
                  <div className="tsti-testimonial-footer">
                    <div className="tsti-project-link">
                      <span>Click to view project →</span>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>

        {/* More Projects Section with Loading Animation */}
        <div className="tsti-more-projects">
          <h2>More Success Stories Coming Soon</h2>
          <p>We're continuously working on exciting new projects</p>
          <div className="tsti-loading-animation">
            <div className="tsti-loading-dot"></div>
            <div className="tsti-loading-dot"></div>
            <div className="tsti-loading-dot"></div>
          </div>
        </div>

        {/* Process Section */}
        <div className="tsti-process-section">
          <div className="tsti-section-title">
            <h2>Our Process</h2>
            <p>How we deliver exceptional results</p>
          </div>
          
          <div className="tsti-process-grid">
            <div className="tsti-process-step">
              <div className="tsti-process-number">01</div>
              <h3>Discovery</h3>
              <p>We understand your vision and requirements</p>
            </div>
            <div className="tsti-process-step">
              <div className="tsti-process-number">02</div>
              <h3>Design</h3>
              <p>Creating stunning designs that reflect your brand</p>
            </div>
            <div className="tsti-process-step">
              <div className="tsti-process-number">03</div>
              <h3>Development</h3>
              <p>Building robust and scalable solutions</p>
            </div>
            <div className="tsti-process-step">
              <div className="tsti-process-number">04</div>
              <h3>Launch</h3>
              <p>Deploying your project with ongoing support</p>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="tsti-cta-section">
          <h3>Ready to be our next success story?</h3>
          <button className="tsti-cta-button">Start Your Project</button>
        </div>
      </div>
    </div>
  );
}

export default Testimonials;